export default __webpack_public_path__ + "static/media/road-E-photo.02547e01.svg";